import { MenuTreeHierarchyProduct } from '@ancon/wildcat-types'
import { createEntityAdapter } from '@reduxjs/toolkit'

const productEntityAdapter = createEntityAdapter<
  MenuTreeHierarchyProduct,
  string
>({
  selectId: product => product.productId,
})

export default productEntityAdapter
